import angular from 'angular';
import NewGamesWidgetComponent from './new-games-widget-component';

export default angular.module('new-games-widget', []).component('newGamesWidget', new NewGamesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/new-games/new-games-widget-module.js